<div class="container px-1 d-flex justify-content-between">
  <div class="selected-category w-50">
    <h4 class="category">
      Produktionsbereich &rarr;
      {{ knowledgeBaseService.selectedProductionLine() | json }}
    </h4>
  </div>
  <div class="selected-category workplace w-50 text-right">
    <h4 class="category">
      Arbeitsplatz &rarr; {{ knowledgeBaseService.selectedWorkplace() | json }}
    </h4>
  </div>
</div>
<!-- <pre>
  ProductionLine: {{ knowledgeBaseService.selectedProductionLine() | json }}
  knowledgeBase Data: {{ knowledgeBaseService.initialData() | json }}
</pre> -->
<!-- <pre>
    User: {{ userService.user()?.app_metadata?.['productionLine'] | json }}
    ProductionLine: {{ knowledgeBaseService.selectedProductionLine() | json }}
    Workplace: {{ selectionService.currentWorkplace | async | json }}
    Process Step: {{ selectionService.currentCategory | async | json }}
    Malfunction: {{ selectionService.currentMalfunction | async | json }}
    Solution: {{ selectionService.currentSolution | async | json }}
    Active Page: {{ selectionService.activePage | async | json }}
    CurrentIncidentId: {{ incidentIdService.incidentId() }}
    CurrentReportId: {{ incidentIdService.reportUuid() }}
    CurrentReport: {{ reportService.currentReport() | json }}
</pre> -->
